
export function productColor(productid) {
    if (productid != null) {
      switch (productid) {
        case 1: return '#38AADE';
        case 2: return '#EE811A';
        case 3: return '#5DB12F';
        default: return '#471747';
      }
    }
    else return '#471747';
  }
